window.$ = window.jQuery = require("jquery");

require("../sass/style.scss");


import {TweenLite, CSSPlugin} from "gsap";
require('../fonts/fontello/css/fontello.css');

require('./vendor/bootstrap-transition');
require('./vendor/bootstrap-collapse');
require('./vendor/owl.carousel');
require('./vendor/bootstrap-tabs-x');
require('./vendor/parallax_background');
require('./vendor/stickUp');


if ($('body').hasClass('home')) {
    require('./home_page');
}

if ($('.contact_section').length > 0) {
    require('./contact.js');
}
if ($('.our_team_section_founders').length > 0) {
    require('./our-team.js');
}
if ($('.investments ').length > 0) {
    require('./investments.js');
}

(function ($) {

    $(window).on('load', function () {
        $('#loader').delay(350).fadeOut('slow');
        $('body').removeClass('overflow');

        var wow = new WOW(
            {
                boxClass: 'wow',      // animated element css class (default is wow)
                animateClass: 'animated', // animation css class (default is animated)
                offset: 0,          // distance to the element when triggering the animation (default is 0)
                mobile: true,       // trigger animations on mobile devices (default is true)
                live: true,       // act on asynchronously loaded content (default is true)
                callback: function (box) {
                    // the callback is fired every time an animation is started
                    // the argument that is passed in is the DOM node being animated
                },
                scrollContainer: null // optional scroll container selector, otherwise use window
            }
        );
        wow.init();
    });
    $('.parallax-background').parallaxBackground();
    $('.gumburger').click(function () {
        $(this).toggleClass('collapsed open-cross');
        $('.menu_colapse').toggleClass('open');
        $('body').toggleClass('overflow2');
    });
    $('#navbar').click(function (e) {
        var target = e.target;
        console.log($(target).parents('.top'));
        if ($(target).parents('.wrap-all').length || $(target).parents('.top').length) {
            console.log('1');
        } else {
            console.log('2');
            $('.gumburger').toggleClass('collapsed open-cross');
            $('.menu_colapse').toggleClass('open');
            $('body').toggleClass('overflow2');
        }

    });

    $(document).on("scroll", function () {
        if ($(document).scrollTop() > 100) {
            $("header").addClass("small");
        } else {
            $("header").removeClass("small");
        }
    });
    var owl = $('.transactions_slider');
    owl.owlCarousel({
        loop: true,
        margin: 20,
        nav: true,
        dots: false,
        autoHeight: true,
        items: 4,
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 1
            },
            768: {
                items: 2
            },
            1200: {
                items: 3
            },
            1500: {
                items: 4
            }
        },
        navText: ['<i class="left"><svg version="1.1" id="IdeaHall_x5F_Website_x5F_DesignTemplate_x5F_121416_xA0_Image"x="0px" y="0px" viewBox="0 0 20 42.8"style="enable-background:new 0 0 20 42.8;" xml:space="preserve"> <style type="text/css">.st0{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}</style> <polyline class="st0" points="18.4,39.8 3.4,21.4 18.4,2.7 "/> </svg> </i>', '<i class="right"><svg version="1.1" id="IdeaHall_x5F_Website_x5F_DesignTemplate_x5F_121416_xA0_Image2" x="0px" y="0px" viewBox="0 0 20 42.8"style="enable-background:new 0 0 20 42.8;" xml:space="preserve"> <style type="text/css">.st0{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}</style> <polyline class="st0" points="2.4,2.7 17.4,21.2 2.4,39.8 "/> </svg> </i>']
    });
    var owl2 = $('.slides');
    owl2.owlCarousel({
        loop: true,
        margin: 20,
        nav: true,
        dots: false,
        autoHeight: true,
        items: 1,
        navText: ['<i class="left"><svg version="1.1" id="IdeaHall_x5F_Website_x5F_DesignTemplate_x5F_121416_xA0_Image"x="0px" y="0px" viewBox="0 0 20 42.8"style="enable-background:new 0 0 20 42.8;" xml:space="preserve"> <style type="text/css">.st0{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}</style> <polyline class="st0" points="18.4,39.8 3.4,21.4 18.4,2.7 "/> </svg> </i>', '<i class="right"><svg version="1.1" id="IdeaHall_x5F_Website_x5F_DesignTemplate_x5F_121416_xA0_Image2" x="0px" y="0px" viewBox="0 0 20 42.8"style="enable-background:new 0 0 20 42.8;" xml:space="preserve"> <style type="text/css">.st0{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}</style> <polyline class="st0" points="2.4,2.7 17.4,21.2 2.4,39.8 "/> </svg> </i>']
    });
    var owl3 = $('.top-image-slider');
    owl3.owlCarousel({
        loop: true,
        margin: 20,
        nav: true,
        dots: true,
        autoplay: true,
        autoplayTimeout: 5000,
        autoHeight: true,
        items: 1,
        navText: ['<i class="left"><svg version="1.1" id="IdeaHall_x5F_Website_x5F_DesignTemplate_x5F_121416_xA0_Image"x="0px" y="0px" viewBox="0 0 20 42.8"style="enable-background:new 0 0 20 42.8;" xml:space="preserve"> <style type="text/css">.st0{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}</style> <polyline class="st0" points="18.4,39.8 3.4,21.4 18.4,2.7 "/> </svg> </i>', '<i class="right"><svg version="1.1" id="IdeaHall_x5F_Website_x5F_DesignTemplate_x5F_121416_xA0_Image2" x="0px" y="0px" viewBox="0 0 20 42.8"style="enable-background:new 0 0 20 42.8;" xml:space="preserve"> <style type="text/css">.st0{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}</style> <polyline class="st0" points="2.4,2.7 17.4,21.2 2.4,39.8 "/> </svg> </i>']
    });


    $(document).ready(function () {



        $('.second-nav a').click(function () {
            var target = $(this).attr("href");
            $('html, body').animate({
                scrollTop: $(target).offset().top - 250

            }, 1500);
            return false;
        })

        $('.second-nav').stickUp({
            topMargin: 75,
        });
        $('.scroll_to').stickUp({
            topMargin: 350,
        });

        $('.go-to a').click(function () {
            var target = $(this).attr("href");
            $('html, body').animate({
                scrollTop: $(target).offset().top - 75

            }, 1500);
            return false;
        })

        $(window).on('scroll', function () {
            $('.show_in_menu').each(function () {
                if ($(window).scrollTop() >= $(this).offset().top - 300) {
                    var id = $(this).attr('id');
                    $('.second-nav a').removeClass('active');
                    $('.second-nav .' + id + '').addClass('active');
                }
            });
        });

    });
    $('.scroll_to a').click(function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $('html, body').offset().top - 250

        }, 1500);
    })
    $('.share').click(function () {
        $('.share').not(this).removeClass('active');
        $(this).toggleClass('active');
    });

})(jQuery);


// WEBPACK FOOTER //
// ./src/js/entry.es6